'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUserAvailableSelector = exports.subscriptionAdminUserSelector = exports.subscriptionTeamSelector = exports.currentUserIsSubscriptionAdminSelector = exports.isGuestSelector = exports.getCurrentUserCustomer = exports.getCurrentUserSubscriptionDetail = exports.getCurrentUserSubscription = exports.getCurrentUserRootBoardId = exports.getCurrentUserEmail = exports.getCurrentUserId = exports.getCurrentUser = undefined;

var _reselect = require('reselect');

var _usersSelector = require('./usersSelector');

var _userUtil = require('./userUtil');

var getCurrentUser = exports.getCurrentUser = function getCurrentUser(state) {
    return state.getIn(['app', 'currentUser']);
}; // Lib
var getCurrentUserId = exports.getCurrentUserId = function getCurrentUserId(state) {
    return state.getIn(['app', 'currentUser', '_id']);
};
var getCurrentUserEmail = exports.getCurrentUserEmail = function getCurrentUserEmail(state) {
    return state.getIn(['app', 'currentUser', 'email']);
};
var getCurrentUserRootBoardId = exports.getCurrentUserRootBoardId = function getCurrentUserRootBoardId(state) {
    return state.getIn(['app', 'currentUser', 'rootBoardId']);
};

var getCurrentUserSubscription = exports.getCurrentUserSubscription = function getCurrentUserSubscription(state) {
    return state.getIn(['app', 'currentUser', 'subscription']);
};
var getCurrentUserSubscriptionDetail = exports.getCurrentUserSubscriptionDetail = function getCurrentUserSubscriptionDetail(state) {
    return state.getIn(['app', 'currentUser', 'subscription', 'detail']);
};
var getCurrentUserCustomer = exports.getCurrentUserCustomer = function getCurrentUserCustomer(state) {
    return state.getIn(['app', 'currentUser', 'customer']);
};

var isGuestSelector = exports.isGuestSelector = (0, _reselect.createSelector)(getCurrentUser, function (currentUser) {
    return currentUser.get('isGuest');
});

var currentUserIsSubscriptionAdminSelector = exports.currentUserIsSubscriptionAdminSelector = (0, _reselect.createSelector)(getCurrentUser, getCurrentUserSubscription, function (currentUser, subscription) {
    return (0, _userUtil.isUserSubscriptionAdmin)(currentUser, subscription);
});

var subscriptionTeamSelector = exports.subscriptionTeamSelector = (0, _reselect.createSelector)(getCurrentUserSubscription, _usersSelector.getUsers, function (subscription, users) {
    var memberIds = subscription && subscription.get('teamMemberIds');
    if (!memberIds) return null;

    return memberIds.map(function (userId) {
        return users.get(userId);
    }).filter(function (user) {
        return user;
    });
});

var subscriptionAdminUserSelector = exports.subscriptionAdminUserSelector = (0, _reselect.createSelector)(getCurrentUserSubscription, _usersSelector.getUsers, function (subscription, users) {
    if (!users || !subscription) return;

    var adminId = subscription.get('adminId');
    return users.get(adminId);
});

var isUserAvailableSelector = exports.isUserAvailableSelector = (0, _reselect.createSelector)(getCurrentUser, isGuestSelector, function (currentUser, isGuest) {
    return isGuest || currentUser.get('authenticated') && currentUser.get('fetched') || false;
});


//////////////////
// WEBPACK FOOTER
// ./src/client/user/currentUserSelector.js
// module id = 33
// module chunks = 0